import { Heading, Spinner, Stack, Text, VStack } from "@chakra-ui/react";
import { useGetAzkarQuery } from "features/apps/service";
import { useTranslation } from "languages";
import { memo, useEffect, useMemo, useState } from "react";

const AzkarSection: React.FC = () => {
  const { translation, isArabic } = useTranslation();
  const { data, isLoading } = useGetAzkarQuery();

  const [currentAzkarIndex, setCurrentAzkarIndex] = useState(0);

  const azkar = useMemo(() => data?.data ?? [], [data]);
  const zikr = useMemo(
    () => (azkar.length > 0 ? azkar[currentAzkarIndex] : {}),
    [azkar, currentAzkarIndex]
  );

  useEffect(() => {
    const moveToNextAzkar = () => {
      if (currentAzkarIndex < azkar.length - 1) {
        setCurrentAzkarIndex(currentAzkarIndex + 1); // Move to the next azkar
      }
    };

    if (azkar.length > 0) {
      // Set timeout for the current azkar
      const timeout = setTimeout(() => {
        moveToNextAzkar();
      }, azkar[currentAzkarIndex].time * 60 * 1000); // Convert minutes to milliseconds

      return () => clearTimeout(timeout); // Cleanup timeout on component unmount or index change
    }
  }, [azkar, currentAzkarIndex]);

  return (
    <VStack align={isArabic ? "flex-end" : "flex-start"} flex={1}>
      <Heading fontSize={"2xl"} textAlign={isArabic ? "right" : "left"}>
        {translation["azkar"]}
      </Heading>
      <Stack
        bgColor={"secondary.300"}
        p={[2, 4]}
        gap={[1, 3]}
        borderRadius={"xl"}
        w="full"
      >
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            <Text
              color={"primary.300"}
              noOfLines={1}
              textAlign={isArabic ? "right" : "left"}
            >
              {zikr?.title}
            </Text>
            <Text noOfLines={1} textAlign={isArabic ? "right" : "left"}>
              {zikr?.description}
            </Text>
          </>
        )}
      </Stack>
    </VStack>
  );
};

export default memo(AzkarSection);
